import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  currentRole: "Choose your role",
  currentTxtRole: "Choose your role",
  EXISTING_ROLES: [
    {
      English: "Choose your role",
    },
    {
      English: "Choose your role",
    },
    {
      English: "CHRO/HR Leader",
    },
    {
      English: "HR Analyst",
    },
    {
      English: "VP Talent Acquisition",
    },
    {
      English: "VP Workforce Intelligence",
    },
    {
      English: "HR IT",
    },
  ],
};

const choose_role = (state, action) => {
  const arrOfRoles = state.EXISTING_ROLES;

  let index;

  arrOfRoles.find(function (obj, idx) {
    if (obj.English === action.role) {
      index = idx;
    }

    return;
  });

  return updateObject(state, {
    currentRole: action.role,
    currentTxtRole: arrOfRoles[index][action.lang],
  });
};

const reducer = (state = initialState, action) => {
  if (action.type === actionTypes.CHOOSE_ROLE) {
    return choose_role(state, action);
  }
  return state;
};

export default reducer;
